import React from "react";

interface ValueWithTargetProps {
  value: number;
  target: number | null;
  format: (value: number) => string;
  className: string;
}

/** A formatted value, with a much smaller "of <target>" suffix when a target applies. */
export default function ValueWithTarget(props: ValueWithTargetProps) {
  const { value, target, format, className } = props;

  return (
    <>
      {format(value)}
      {target !== null && (
        <span className={className}> of {format(target)}</span>
      )}
    </>
  );
}
